var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
import { InputCheckboxList } from '@isyc-react/form/modules/input/option/checkbox';
import { useParameterTemplateReadQuery } from '@isyc-react/oncustomer/modules/objects/parameter/base';
import { getParameterDisabled, validBailleursParameter } from './rhf-input-bailleurs-parameter.component';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
import { RhfFieldError, rhfMapperReq, useController } from '@isyc-react/form/modules/rhf';
const sep = ',';
export const InputParameterSelectCheckboxBase = props => {
    const { value: valueProp, onChange, required, justify, parameterId, max } = props, rest = __rest(props, ["value", "onChange", "required", "justify", "parameterId", "max"]);
    const { data, loading, error } = useParameterTemplateReadQuery({ variables: { id: parameterId } });
    const { labels, values } = React.useMemo(() => {
        const options = {
            labels: [],
            values: [],
        };
        if (data && data.parameterTemplate_read && data.parameterTemplate_read.defaultValues) {
            data.parameterTemplate_read.defaultValues
                .filter(df => df !== null)
                .forEach(df => {
                options.labels.push(df.text);
                options.values.push({ checked: false, indeterminate: false, data: df });
            });
        }
        return options;
    }, [data]);
    const value = React.useMemo(() => {
        var _a;
        const valueArray = (_a = valueProp === null || valueProp === void 0 ? void 0 : valueProp.split(sep)) !== null && _a !== void 0 ? _a : [];
        const result = [];
        values.forEach(v => {
            const item = Object.assign(Object.assign({}, v), { checked: v.data && valueProp ? valueArray.includes(v.data.code) : false });
            result.push(item);
        });
        return result;
    }, [values, valueProp]);
    // TODO error and improve loading
    return (React.createElement(React.Fragment, null, loading ? (React.createElement(Spinner, { animation: 'border', size: 'sm' })) : (React.createElement(InputCheckboxList, Object.assign({ justify: justify, value: value, labels: labels, className: 'parameter-select-checkbox-container', onChange: change => {
            const checked = change.filter(c => c.checked);
            onChange && onChange(checked.map(c => { var _a, _b; return (_b = (_a = c.data) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : ''; }).join(sep));
        }, max: max }, rest)))));
};
export const InputParameterSelectCheckbox = props => {
    const _a = useFormCommonProps(props), { value, data, onChange, readOnly, disabled, justify, getDisabled = getParameterDisabled } = _a, rest = __rest(_a, ["value", "data", "onChange", "readOnly", "disabled", "justify", "getDisabled"]);
    // TODO use comboCodeLabel as default selected label in the select and defaultvalues options
    const { value: parameterValue, comboCodeLabel, relatedObjectName, relatedObjectType } = value;
    const { parameterType, obligatory, parameterId } = data;
    const parameterDisabled = React.useMemo(() => getDisabled(data, readOnly, disabled), [data, readOnly, disabled]);
    const parameterChange = React.useCallback((field) => {
        onChange && onChange(Object.assign(Object.assign({}, value), field));
    }, [value, onChange]);
    return (React.createElement(InputParameterSelectCheckboxBase, Object.assign({ value: parameterValue, onChange: c => parameterChange({ value: c }), parameterId: parameterId, required: obligatory, disabled: parameterDisabled, justify: justify }, rest)));
};
export const RhfInputBailleursParameterSelectCheckbox = props => {
    const { rhf, errorMessage, input } = props;
    const { field: { onChange, onBlur, name, value, ref }, fieldState: { error }, } = useController(rhfMapperReq(rhf, (p) => Boolean(p.value), {
        valid: (p) => validBailleursParameter(p.value, p),
    }));
    const data = value;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(InputParameterSelectCheckbox, Object.assign({ onChange: onChange, onBlur: onBlur, value: value, data: data, error: Boolean(error), getDisabled: getParameterDisabled }, input)),
            React.createElement(RhfFieldError, { errorMessage: errorMessage, error: error }))));
};
